import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n    margin-top: -16px;\n    font-size: 14px;\n    line-height: 110%;\n  "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  text-transform: uppercase;\n  font: 18px ", ";\n  line-height: 1.1em;\n  justify-content: flex-end;\n  color: ", ";\n  margin-bottom: 8px;\n  ", "\n  ", "\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 2px;\n    font-size: 16px;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    font-size: 20px;\n    line-height: 100%;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  font: 24px ", ";\n  margin-bottom: 8px;\n  line-height: 1em;\n  text-transform: capitalize;\n  display: inline-block;\n  ", "\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    font-size: 10px;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    width: 100px;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    max-width: 100%;\n    width: 150px;\n    white-space: nowrap;\n    font-size: 14px;\n    line-height: 160%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    &.show {\n      white-space: normal;\n      width: 90%;\n      overflow: auto;\n    }\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  max-width: 70%;\n  color: #839098;\n  font: 16px ", ";\n  line-height: 1.6em;\n  span {\n    color: #4f6e7c;\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  &.show {\n    display: block;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    width: 64px;\n    height: 64px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    width: 100px;\n    height: 100px;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  flex-shrink: 0;\n  width: 148px;\n  height: 148px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  border-radius: 6px;\n  img {\n    max-width: 90%;\n    max-height: 90%;\n    width: auto;\n    height: auto;\n  }\n  ", "\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-size: 10px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 160%;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: #839098;\n  font: 16px ", ";\n  line-height: 1.6em;\n  span {\n    color: #4f6e7c;\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 0 0 16px;\n    flex-grow: 1;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 16px 0 0 16px;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 30px 0;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  align-content: stretch;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), function (props) {
  return props.theme.colors.light;
});
export var Details = styled.div(_templateObject2(), media.xxLargeScreen(_templateObject3()));
export var Category = styled.div(_templateObject4(), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject5()), media.smallScreen(_templateObject6()), media.extraSmallScreen(_templateObject7()));
export var Photo = styled.div(_templateObject8(), function (props) {
  return props.theme.colors.light;
}, media.xxLargeScreen(_templateObject9()), media.smallScreen(_templateObject10()));
export var Wr = styled.div(_templateObject11());
export var Sku = styled.div(_templateObject12(), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject13()), media.smallScreen(_templateObject14()), media.extraSmallScreen(_templateObject15()));
export var Name = styled.div(_templateObject16(), function (props) {
  return props.theme.typography.thinFontFamily;
}, media.xxLargeScreen(_templateObject17()), media.smallScreen(_templateObject18()));
export var Price = styled.div(_templateObject19(), function (props) {
  return props.theme.typography.extraFontFamily;
}, function (props) {
  return props.theme.colors.red;
}, media.xxLargeScreen(_templateObject20()), media.smallScreen(_templateObject21()));